import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CustomerReportingPage } from './customer-reporting.page';
import { BrowserPageTitle } from '@shared/constants/browser-page-title.enum';
import { PATHS } from '@shared/constants/paths';

const routes: Routes = [
  {
    path: '',
    component: CustomerReportingPage,
    pathMatch: 'full',
    data: { title: BrowserPageTitle.businessAnalytics },
  },
  {
    path: PATHS.CUSTOMER_REPORTING_DETAIL_DATA,
    loadChildren: () =>
      import('./pages/detail-data/detail-data.module').then(
        m => m.DetailDataPageModule,
      ),
  },
  {
    path: PATHS.CUSTOMER_REPORTING_PRODUCT_USAGE,
    loadChildren: () =>
      import('./pages/product-usage/product-usage.module').then(
        m => m.ProductUsagePageModule,
      ),
  },
  {
    path: PATHS.CUSTOMER_REPORTING_INVOICE_HISTORY,
    loadChildren: () =>
      import('./pages/invoice-history/invoice-history.module').then(
        m => m.InvoiceHistoryPageModule,
      ),
  },
  {
    path: PATHS.CUSTOMER_REPORTING_SERVICE_LEVEL,
    loadChildren: () =>
      import('./pages/service-level/service-level.module').then(
        m => m.ServiceLevelPageModule,
      ),
  },
  {
    path: PATHS.CUSTOMER_REPORTING_CONTRACT_PRODUCT_UTILIZATION,
    loadChildren: () =>
      import(
        './pages/contract-product-utilization/contract-product-utilization.module'
      ).then(m => m.ContractProductUtilizationPageModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerReportingPageRoutingModule {}
